import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * MIKE (Maiores Altas e Baixas com a Média HLC, FML.MIKE) — overlay de preço,
 * 6 linhas: WR/MR/SR (resistências) e WS/MS/SS (suportes).
 * yAccessor(d) retorna { wr, mr, sr, ws, ms, ss }.
 */
const LINES = [
  ["wr", "strokeWr"],
  ["mr", "strokeMr"],
  ["sr", "strokeSr"],
  ["ws", "strokeWs"],
  ["ms", "strokeMs"],
  ["ss", "strokeSs"],
];

class MIKESeries extends Component {
  constructor(props) {
    super(props);
    // Um accessor por linha, criado uma única vez (nada de closure em render).
    this.accessors = LINES.reduce((acc, [key]) => {
      acc[key] = (d) => {
        const v = this.props.yAccessor(d);
        return v && v[key];
      };
      return acc;
    }, {});
  }
  render() {
    const { className } = this.props;
    return (
      <g className={className}>
        {LINES.map(([key, strokeProp]) => (
          <LineSeries
            key={key}
            yAccessor={this.accessors[key]}
            stroke={this.props[strokeProp]}
            fill="none"
          />
        ))}
      </g>
    );
  }
}

const strokeType = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);

MIKESeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeWr: strokeType,
  strokeMr: strokeType,
  strokeSr: strokeType,
  strokeWs: strokeType,
  strokeMs: strokeType,
  strokeSs: strokeType,
  className: PropTypes.string,
};

// Paleta default do engine, por ÍNDICE de série (FormulaBase.DefaultColors).
MIKESeries.defaultProps = {
  strokeWr: { color: "#FFFF00" },
  strokeMr: { color: "#FF0000" },
  strokeSr: { color: "#0000B4" },
  strokeWs: { color: "#A9A9A9" },
  strokeMs: { color: "#1E90FF" },
  strokeSs: { color: "#800080" },
  className: "react-stockcharts-mike-series",
};

export default MIKESeries;
